import './App.css';
import Home from './components/Home';
import Navigation from './components/Navigation';

function App() {
  return (
    <>
      <Navigation />
      <Home />
    </>
  );
}

export default App;
